export const MOBILE = { query: "(max-width: 650px)" };

export const DESKTOP = { query: "(min-width: 651px)" };

export const TABLET = { query: "(max-width: 865px)" };

export const TABLET2 = { query: "(min-width: 900px, max-width: 1199px)" };
